import { useEffect, useState } from 'react';
import { RudderAnalytics } from '@rudderstack/analytics-js';

const useRudderStackAnalytics = () => {
  const [analytics, setAnalytics] = useState();

  useEffect(() => {
    if (!analytics) {
      const analyticsInstance = new RudderAnalytics();
      analyticsInstance.load("2zZkzOwsIu8Gbwqq9SbUPJ3Om2u", "https://thefruitbohgv.dataplane.rudderstack.com",{});
      setAnalytics(analyticsInstance);
    }
  }, [analytics]);

  return analytics;
};

export default useRudderStackAnalytics;